module.exports = __webpack_public_path__ + "static/honey-fd8ae348e871d1868ff75f9d6fd10a2c.jpg";